module.exports = __webpack_public_path__ + "static/media/Jordan.da001fee.png";